<template>
  <slot />
</template>

<script setup lang="ts">
const props = defineProps({
  on: {
    type: Boolean,
    required: true,
  },
})
if (props.on) {
  useViewportPriority(true)
}
</script>
